var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAppstore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 40,
    viewBox: "0 0 110 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_appstore",
    transform: "translate(-352 -457)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 110,
    height: 40,
    rx: 4,
    transform: "translate(352 457)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cont",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M15.034,11.685A4.967,4.967,0,0,1,17.419,7.5a5.182,5.182,0,0,0-4.039-2.186c-1.723-.173-3.363,1.011-4.233,1.011S6.926,5.345,5.5,5.373A5.414,5.414,0,0,0,.925,8.128c-1.949,3.367-.5,8.356,1.4,11.086C3.255,20.551,4.361,22.051,5.813,22c1.4-.054,1.932-.9,3.625-.9s2.168.9,3.65.878c1.505-.031,2.461-1.368,3.38-2.7A12.177,12.177,0,0,0,18,16.139a4.857,4.857,0,0,1-2.966-4.454M12.249,3.51A4.81,4.81,0,0,0,13.4,0a4.958,4.958,0,0,0-3.253,1.665A4.6,4.6,0,0,0,8.971,5.07a4.109,4.109,0,0,0,3.277-1.56",
    transform: "translate(363 465.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "txt",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "App_Store",
    "data-name": "App Store",
    transform: "translate(390 488)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Bold, Pretendard",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "App Store")), /*#__PURE__*/React.createElement("text", {
    id: "Download_on_the",
    "data-name": "Download on the",
    transform: "translate(390 473)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Pretendard-Regular, Pretendard",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download on the")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAppstore);
export default __webpack_public_path__ + "static/media/logo_appstore.819bd42e6a51f4932c3d4e5b029e10fa.svg";
export { ForwardRef as ReactComponent };